module.exports = __webpack_public_path__ + "img/resume-style-2.65cffd2d.jpeg";